import React from 'react';
import PropTypes from 'prop-types';
import { Box, VStack, Text, Image } from '@chakra-ui/react';
import { getImageUrl } from 'utils/ImageImporter';

function AssignmentCard({ prompt, selectAssignment }) {
  const {
    essayType,
    primaryType,
    essayPrompt,
    promptTitle,
    shortPrompt,
    url,
    promptId,
    level,
    illustration,
    minWordCount,
  } = prompt;
  const title = promptTitle || shortPrompt || essayPrompt;

  // console.log('coming prompt: ', prompt);

  const promptData = {
    promptId,
    essayTitle: promptTitle,
    level,
    essayType: primaryType,
    url: illustration,
    essayPrompt,
    minWordCount,
  };

  function capitalizeType(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1) + ' Writing';
  }

  return (
    <Box
      borderRadius="md"
      overflow="hidden"
      boxShadow="md"
      borderWidth="1px"
      maxW={{ base: 'none', md: 'sm' }}
      w="full"
      cursor="pointer"
      onClick={() => selectAssignment(promptData)}
    >
      {/* Upper Part: Image */}
      <Box position="relative" w="100%" pt="66%">
        {' '}
        {/* 3:2 Aspect Ratio */}
        <Image
          src={getImageUrl(url || essayType)}
          alt={title}
          position="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          objectFit="cover"
          transition="0.3s ease-in-out"
          _hover={{
            transform: 'scale(1.05)',
          }}
        />
      </Box>

      {/* Bottom Part: Content */}
      <VStack align="start" p={4} spacing={1}>
        <Text
          fontWeight="bold"
          fontSize="sm"
          display="-webkit-box"
          overflow="hidden"
          sx={{
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}
          lineHeight="1.2"
        >
          {title}
        </Text>
        <Text fontSize="sm" color="gray.600">
          {capitalizeType(essayType)}
        </Text>
      </VStack>
    </Box>
  );
}

AssignmentCard.propTypes = {
  prompt: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  selectAssignment: PropTypes.func.isRequired,
};

export default AssignmentCard;
